
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire377e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire377e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("en8y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a769d83a4ef5f8e5$export$2e2bcd8739ae039);
function $a769d83a4ef5f8e5$var$mapStoreToNumber(callback) {
    return (input)=>{
        return callback($a769d83a4ef5f8e5$var$isNumber(input) ? input : input.get());
    };
}
function $a769d83a4ef5f8e5$var$getSsrHandler(pluginList) {
    const ssrPlugin = pluginList.find(({ name: name })=>name === 'ssr');
    return ssrPlugin;
}
function $a769d83a4ef5f8e5$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $a769d83a4ef5f8e5$var$isString(subject) {
    return typeof subject === 'string';
}
function $a769d83a4ef5f8e5$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $a769d83a4ef5f8e5$var$mathAbs(input) {
    return Math.abs(input);
}
function $a769d83a4ef5f8e5$var$mathSign(input) {
    return Math.sign(input);
}
function $a769d83a4ef5f8e5$var$deltaAbs(inputB, inputA) {
    return $a769d83a4ef5f8e5$var$mathAbs(inputB - inputA);
}
function $a769d83a4ef5f8e5$var$factorAbs(inputB, inputA) {
    if (inputB === 0 || inputA === 0) return 0;
    if ($a769d83a4ef5f8e5$var$mathAbs(inputB) <= $a769d83a4ef5f8e5$var$mathAbs(inputA)) return 0;
    const diff = $a769d83a4ef5f8e5$var$deltaAbs($a769d83a4ef5f8e5$var$mathAbs(inputB), $a769d83a4ef5f8e5$var$mathAbs(inputA));
    return $a769d83a4ef5f8e5$var$mathAbs(diff / inputB);
}
function $a769d83a4ef5f8e5$var$roundToTwoDecimals(input) {
    return Math.round(input * 100) / 100;
}
function $a769d83a4ef5f8e5$var$arrayKeys(array) {
    return $a769d83a4ef5f8e5$var$objectKeys(array).map(Number);
}
function $a769d83a4ef5f8e5$var$arrayLast(array) {
    return array[$a769d83a4ef5f8e5$var$arrayLastIndex(array)];
}
function $a769d83a4ef5f8e5$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $a769d83a4ef5f8e5$var$arrayIsLastIndex(array, index) {
    return index === $a769d83a4ef5f8e5$var$arrayLastIndex(array);
}
function $a769d83a4ef5f8e5$var$arrayFromRange(end, start = 0) {
    return Array.from(Array(end - start + 1), (_, index)=>start + index);
}
function $a769d83a4ef5f8e5$var$objectKeys(object) {
    return Object.keys(object);
}
function $a769d83a4ef5f8e5$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $a769d83a4ef5f8e5$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $a769d83a4ef5f8e5$var$isObject(valueA) && $a769d83a4ef5f8e5$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $a769d83a4ef5f8e5$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $a769d83a4ef5f8e5$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $a769d83a4ef5f8e5$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(input) {
        return end(input) / 2;
    }
    function end(input) {
        return viewSize - input;
    }
    function measure(input, index) {
        if ($a769d83a4ef5f8e5$var$isString(align)) return predefined[align](input);
        return align(viewSize, input, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $a769d83a4ef5f8e5$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $a769d83a4ef5f8e5$var$Animations(update, render) {
    const documentVisibleHandler = $a769d83a4ef5f8e5$var$EventStore();
    const fixedTimeStep = 1000 / 60;
    let windowInstance;
    let lastTimeStamp = null;
    let accumulatedTime = 0;
    let animationId = 0;
    function init(ownerWindow) {
        const ownerDocument = ownerWindow.document;
        windowInstance = ownerWindow;
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        const timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        const alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = windowInstance.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = windowInstance.requestAnimationFrame(animate);
    }
    function stop() {
        if (!animationId) return;
        windowInstance.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $a769d83a4ef5f8e5$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    const nativeScroll = isVertical ? 'scrollTop' : 'scrollLeft';
    function getSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(input) {
        return input * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        nativeScroll: nativeScroll,
        getSize: getSize,
        direction: $a769d83a4ef5f8e5$var$mapStoreToNumber(direction)
    };
    return self;
}
function $a769d83a4ef5f8e5$var$Limit(min = 0, max = 0) {
    const length = $a769d83a4ef5f8e5$var$mathAbs(min - max);
    function pastMinBound(input) {
        return input < min;
    }
    function pastMaxBound(input) {
        return input > max;
    }
    function pastAnyBound(input) {
        return pastMinBound(input) || pastMaxBound(input);
    }
    function clamp(input) {
        if (!pastAnyBound(input)) return input;
        return pastMinBound(input) ? min : max;
    }
    function removeOffset(input) {
        if (!length) return input;
        return input - length * Math.ceil((input - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        clamp: $a769d83a4ef5f8e5$var$mapStoreToNumber(clamp),
        pastAnyBound: $a769d83a4ef5f8e5$var$mapStoreToNumber(pastAnyBound),
        pastMaxBound: $a769d83a4ef5f8e5$var$mapStoreToNumber(pastMaxBound),
        pastMinBound: $a769d83a4ef5f8e5$var$mapStoreToNumber(pastMinBound),
        removeOffset: $a769d83a4ef5f8e5$var$mapStoreToNumber(removeOffset)
    };
    return self;
}
function $a769d83a4ef5f8e5$var$Counter(max, start, loop) {
    const { clamp: clamp } = $a769d83a4ef5f8e5$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = normalize(start);
    function normalize(input) {
        return !loop ? clamp(input) : $a769d83a4ef5f8e5$var$mathAbs((loopEnd + input) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(input) {
        counter = normalize(input);
        return self;
    }
    function add(input) {
        return clone().set(get() + input);
    }
    function clone() {
        return $a769d83a4ef5f8e5$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $a769d83a4ef5f8e5$var$DragHandler(active, axis, rootNode, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, indexCurrent, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $a769d83a4ef5f8e5$var$EventStore();
    const mouseEvents = $a769d83a4ef5f8e5$var$EventStore();
    const goToNextThreshold = $a769d83a4ef5f8e5$var$Limit(50, 225).clamp(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const dragFreeEnabled = dragFree === true || dragFree === 'snap';
    const settlesOnSnapPoint = dragFree !== true;
    const baseDuration = dragFreeEnabled ? 43 : 25;
    let documentInstance;
    let windowInstance;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let runTouchEvents = false;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(ownerWindow) {
        if (!active) return;
        documentInstance = ownerWindow.document;
        windowInstance = ownerWindow;
        dragTracker.init(ownerWindow);
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', (e)=>runTouchEvents && move(e), nonPassiveEvent).add(node, 'touchend', (e)=>runTouchEvents && up(e)).add(node, 'touchstart', down).add(node, 'mousedown', down).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        mouseEvents.clear();
        runTouchEvents = false;
    }
    function addMouseEvents() {
        const node = isMouse ? documentInstance : rootNode;
        mouseEvents.add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFreeEnabled ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function indexChanged() {
        const currentLocation = scrollTarget.byDistance(0, false);
        return currentLocation.index !== indexCurrent.get();
    }
    function baseForce(force) {
        return scrollTarget.byDistance(force, settlesOnSnapPoint).distance;
    }
    function allowedForce(force) {
        const next = indexCurrent.add($a769d83a4ef5f8e5$var$mathSign(force) * -1);
        if (dragFreeEnabled || $a769d83a4ef5f8e5$var$mathAbs(force) < goToNextThreshold) return baseForce(force);
        if (skipSnaps && indexChanged()) return baseForce(force) * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const event = eventHandler.createEvent('pointerdown', evt);
        const preventDefault = !event.emit();
        if (preventDefault) return;
        const isMouseEvt = $a769d83a4ef5f8e5$var$isMouseEvent(evt, windowInstance);
        const isNotLeftButton = isMouseEvt && evt.button !== 0;
        isMouse = isMouseEvt;
        preventClick = dragFreeEnabled && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $a769d83a4ef5f8e5$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isNotLeftButton) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        addMouseEvents();
        runTouchEvents = true;
    }
    function move(evt) {
        const event = eventHandler.createEvent('pointermove', evt);
        const preventDefault = !event.emit();
        if (preventDefault) return up(evt);
        const isTouchEvt = !$a769d83a4ef5f8e5$var$isMouseEvent(evt, windowInstance);
        const isPinching = isTouchEvt && evt.touches.length >= 2;
        if (isPinching) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $a769d83a4ef5f8e5$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $a769d83a4ef5f8e5$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        if (evt.cancelable) evt.preventDefault();
    }
    function up(evt) {
        const event = eventHandler.createEvent('pointerup', evt);
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce));
        const forceFactor = $a769d83a4ef5f8e5$var$factorAbs(rawForce, force);
        const duration = baseDuration - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        runTouchEvents = false;
        isMouse = false;
        mouseEvents.clear();
        scrollBody.useDuration(duration).useFriction(friction);
        scrollTo.distance(force, settlesOnSnapPoint);
        event.emit();
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $a769d83a4ef5f8e5$var$DragTracker(axis) {
    const logInterval = 170;
    let windowInstance;
    let startEvent;
    let lastEvent;
    function init(ownerWindow) {
        windowInstance = ownerWindow;
    }
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($a769d83a4ef5f8e5$var$isMouseEvent(evt, windowInstance) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $a769d83a4ef5f8e5$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        init: init,
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $a769d83a4ef5f8e5$var$PercentOfView(viewSize) {
    function measure(input) {
        return viewSize * (input / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ResizeHandler(active, container, eventHandler, slides, axis, nodeHandler) {
    const observeNodes = [
        container,
        ...slides
    ];
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.getSize(nodeHandler.getRect(node));
    }
    function init(ownerWindow) {
        if (!active) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        resizeObserver = new ownerWindow.ResizeObserver(onResize);
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    function onResize(entries) {
        const event = eventHandler.createEvent('resize', entries);
        const preventDefault = !event.emit();
        if (preventDefault) return;
        for (const entry of entries){
            if (destroyed) return;
            const isContainer = entry.target === container;
            const slideIndex = slides.indexOf(entry.target);
            const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
            const newSize = readSize(isContainer ? container : slides[slideIndex]);
            const diffSize = $a769d83a4ef5f8e5$var$mathAbs(newSize - lastSize);
            if (diffSize >= 0.5) {
                event.api.reInit();
                break;
            }
        }
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollAnimator() {
    function update(engine) {
        const { dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } } = engine;
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    }
    function render(engine, alpha) {
        const { scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, previousLocation: previousLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } } = engine;
        const isIdle = scrollBody.settled();
        const isWithinBounds = !scrollBounds.shouldConstrain();
        const isPointerDown = dragHandler.pointerDown();
        const canSettle = loop || isWithinBounds;
        const isIdleAndCanSettle = isIdle && canSettle;
        const isScrolling = !isIdleAndCanSettle;
        const isDragging = isScrolling && isPointerDown;
        const isSettled = isIdleAndCanSettle && !isPointerDown;
        if (isSettled) animation.stop();
        const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation);
        if (isSettled) {
            const event = eventHandler.createEvent('settle', null);
            event.emit();
        }
        if (isScrolling) {
            const event = eventHandler.createEvent('scroll', {
                isDragging: isDragging
            });
            event.emit();
        }
    }
    const self = {
        update: update,
        render: render
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let scrollVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const displacement = target.minus(location);
        const isInstant = !scrollDuration;
        let scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $a769d83a4ef5f8e5$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const displacement = target.minus(offsetLocation);
        return $a769d83a4ef5f8e5$var$mathAbs(displacement) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(input) {
        scrollDuration = input;
        return self;
    }
    function useFriction(input) {
        scrollFriction = input;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const { pastAnyBound: pastAnyBound, pastMinBound: pastMinBound, clamp: clamp } = limit;
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $a769d83a4ef5f8e5$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!pastAnyBound(target)) return false;
        if (!pastAnyBound(location)) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = pastMinBound(location) ? 'min' : 'max';
        const diffToEdge = $a769d83a4ef5f8e5$var$mathAbs(limit[edge] - location.get());
        const displacement = target.minus(location);
        const friction = frictionLimit.clamp(diffToEdge / edgeOffsetTolerance);
        target.subtract(displacement * friction);
        if (!pointerDown && $a769d83a4ef5f8e5$var$mathAbs(displacement) < pullBackThreshold) {
            target.set(clamp(target));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $a769d83a4ef5f8e5$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = getSnapsBounded();
    const scrollContainLimit = getScrollContainLimit();
    const snapsContained = getSnapsContained();
    function usePixelTolerance(bound, snap) {
        return pixelTolerance ? $a769d83a4ef5f8e5$var$deltaAbs(bound, snap) <= 1 : false;
    }
    function getScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $a769d83a4ef5f8e5$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $a769d83a4ef5f8e5$var$Limit(min, max);
    }
    function getSnapsBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.clamp(snapAligned);
            const isFirst = !index;
            const isLast = $a769d83a4ef5f8e5$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function getSnapsContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $a769d83a4ef5f8e5$var$arrayLast(scrollSnaps);
    const limit = $a769d83a4ef5f8e5$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollLooper(contentSize, limit, location, loopEntities) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { pastMinBound: pastMinBound, pastMaxBound: pastMaxBound } = $a769d83a4ef5f8e5$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return pastMaxBound(location);
        if (direction === -1) return pastMinBound(location);
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        loopEntities.forEach((loopEntity)=>loopEntity.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(input) {
        const currentLocation = input - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: $a769d83a4ef5f8e5$var$mapStoreToNumber(get)
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$a769d83a4ef5f8e5$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($a769d83a4ef5f8e5$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$a769d83a4ef5f8e5$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollSnapList(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes, scrollProgress) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slidesBySnap = getSlidesBySnap();
    const snapBySlide = getSnapsBySlide();
    const progressBySnap = scrollSnaps.map(scrollProgress.get);
    const length = scrollSnaps.length;
    function getSlidesBySnap() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $a769d83a4ef5f8e5$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const rangeEnd = $a769d83a4ef5f8e5$var$arrayLast(group);
                return $a769d83a4ef5f8e5$var$arrayFromRange(rangeEnd);
            }
            if (isLast) {
                const rangeEnd = $a769d83a4ef5f8e5$var$arrayLastIndex(slideIndexes);
                return $a769d83a4ef5f8e5$var$arrayFromRange(rangeEnd, group[0]);
            }
            return group;
        });
    }
    function getSnapsBySlide() {
        const snapBySlide = {};
        slidesBySnap.forEach((slideGroup, snapIndex)=>{
            slideGroup.forEach((slideIndex)=>{
                snapBySlide[slideIndex] = snapIndex;
            });
        });
        return snapBySlide;
    }
    const self = {
        slidesBySnap: slidesBySnap,
        snapBySlide: snapBySlide,
        progressBySnap: progressBySnap,
        length: length
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { pastAnyBound: pastAnyBound, removeOffset: removeOffset, clamp: clamp } = limit;
    function minDistance(distances) {
        return distances.sort((a, b)=>$a769d83a4ef5f8e5$var$mathAbs(a) - $a769d83a4ef5f8e5$var$mathAbs(b))[0];
    }
    function getClosestSnap(target) {
        const distance = loop ? removeOffset(target) : clamp(target);
        const { index: index } = scrollSnaps.reduce((result, snap, snapIndex)=>{
            const displacementAbs = $a769d83a4ef5f8e5$var$mathAbs(shortcut(snap - distance, 0));
            if (displacementAbs >= result.smallestDisplacement) return result;
            return {
                smallestDisplacement: displacementAbs,
                index: snapIndex
            };
        }, {
            smallestDisplacement: Infinity,
            index: 0
        });
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        if (!loop) return target;
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!direction) return minDistance(targets);
        const validTargets = targets.filter((t)=>$a769d83a4ef5f8e5$var$mathSign(t) === direction);
        if (validTargets.length) return minDistance(validTargets);
        return $a769d83a4ef5f8e5$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snapToClosest) {
        const target = targetVector.plus(distance);
        const { index: index, distance: targetSnapDistance } = getClosestSnap(target);
        const isPastAnyBound = !loop && pastAnyBound(target);
        if (!snapToClosest || isPastAnyBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $a769d83a4ef5f8e5$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const { index: targetSnap, distance: targetDisplacement } = target;
        const sourceSnap = indexCurrent.get();
        const hasIndexChanged = targetSnap !== sourceSnap;
        if (targetDisplacement) {
            targetVector.add(targetDisplacement);
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (hasIndexChanged) {
            indexPrevious.set(sourceSnap);
            indexCurrent.set(targetSnap);
            const event = eventHandler.createEvent('select', {
                targetSnap: targetSnap,
                sourceSnap: sourceSnap
            });
            event.emit();
        }
    }
    function distance(input, snapToClosest) {
        const target = scrollTarget.byDistance(input, snapToClosest);
        scrollTo(target);
    }
    function index(input, direction) {
        const targetIndex = indexCurrent.clone().set(input).get();
        const target = scrollTarget.byIndex(targetIndex, getDirection(direction));
        scrollTo(target);
    }
    function getDirection(direction) {
        if (!direction) return 0;
        if ($a769d83a4ef5f8e5$var$isNumber(direction)) return direction;
        return direction === 'forward' ? -1 : 1;
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $a769d83a4ef5f8e5$var$SlideFocus(axis, active, root, slides, scrollSnapList, scrollTo, scrollBody, eventStore, eventHandler) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(ownerWindow) {
        if (!active) return;
        eventStore.add(ownerWindow.document, 'keydown', onKeyDown, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, 'focus', (evt)=>onFocus(evt, slideIndex), focusListenerOptions);
        });
    }
    function onFocus(evt, slideIndex) {
        const nowTime = new Date().getTime();
        const diffTime = nowTime - lastTabPressTime;
        if (diffTime > 10) return;
        const event = eventHandler.createEvent('slidefocus', evt);
        const preventDefault = !event.emit();
        if (preventDefault) return;
        root[axis.nativeScroll] = 0;
        const snapIndex = scrollSnapList.snapBySlide[slideIndex];
        if (!$a769d83a4ef5f8e5$var$isNumber(snapIndex)) return;
        scrollBody.useDuration(0);
        scrollTo.index(snapIndex, 0);
    }
    function onKeyDown(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $a769d83a4ef5f8e5$var$NumberStore(initialValue) {
    let value = initialValue || 0;
    function get() {
        return value;
    }
    function set(input) {
        value = input;
    }
    function add(input) {
        value += input;
    }
    function subtract(input) {
        add(-input);
    }
    function plus(input) {
        return value + input;
    }
    function minus(input) {
        return plus(-input);
    }
    const self = {
        get: get,
        set: $a769d83a4ef5f8e5$var$mapStoreToNumber(set),
        add: $a769d83a4ef5f8e5$var$mapStoreToNumber(add),
        subtract: $a769d83a4ef5f8e5$var$mapStoreToNumber(subtract),
        plus: $a769d83a4ef5f8e5$var$mapStoreToNumber(plus),
        minus: $a769d83a4ef5f8e5$var$mapStoreToNumber(minus)
    };
    return self;
}
function $a769d83a4ef5f8e5$var$SlideLooper(viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slideTranslates) {
    const roundingSafety = 0.5;
    const ascItems = $a769d83a4ef5f8e5$var$arrayKeys(slideSizesWithGaps);
    const descItems = $a769d83a4ef5f8e5$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function getRemainingGapAfterSlides(indexes, from) {
        return indexes.reduce((remainingGap, index)=>{
            return remainingGap - slideSizesWithGaps[index];
        }, from);
    }
    function getSlidesThatFitGap(indexes, gap) {
        return indexes.reduce((slidesThatFit, index)=>{
            const remainingGap = getRemainingGapAfterSlides(slidesThatFit, gap);
            return remainingGap > 0 ? [
                ...slidesThatFit,
                index
            ] : slidesThatFit;
        }, []);
    }
    function getSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function getLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = getSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $a769d83a4ef5f8e5$var$NumberStore(-1),
                translate: slideTranslates[index],
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = getSlidesThatFitGap(descItems, gap);
        return getLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = getSlidesThatFitGap(ascItems, gap);
        return getLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return getRemainingGapAfterSlides(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    const self = {
        canLoop: canLoop,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $a769d83a4ef5f8e5$var$SlidesHandler(active, container, eventHandler) {
    let mutationObserver;
    let destroyed = false;
    function init(ownerWindow) {
        if (!active) return;
        mutationObserver = new ownerWindow.MutationObserver(onSlidesChange);
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    function onSlidesChange(mutations) {
        const event = eventHandler.createEvent('slideschanged', mutations);
        const preventDefault = !event.emit();
        if (preventDefault) return;
        for (const mutation of mutations){
            if (destroyed) return;
            if (mutation.type === 'childList') {
                event.api.reInit();
                break;
            }
        }
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $a769d83a4ef5f8e5$var$SlidesInView(container, slides, eventHandler, threshold, rootMargin) {
    const slidesInView = new Set();
    let intersectionObserver;
    let destroyed = false;
    function init(ownerWindow) {
        intersectionObserver = new ownerWindow.IntersectionObserver(onIntersection, {
            root: container.parentElement,
            threshold: threshold,
            rootMargin: rootMargin
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function onIntersection(entries) {
        const slidesEnterView = [];
        const slidesLeftView = [];
        for (const entry of entries){
            if (destroyed) return;
            const index = slides.indexOf(entry.target);
            if (entry.isIntersecting) {
                slidesInView.add(index);
                slidesEnterView.push(index);
            } else {
                slidesInView.delete(index);
                slidesLeftView.push(index);
            }
        }
        const event = eventHandler.createEvent('slidesinview', {
            slidesInView: get(),
            slidesLeftView: slidesLeftView,
            slidesEnterView: slidesEnterView
        });
        event.emit();
    }
    function get() {
        return [
            ...slidesInView
        ];
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $a769d83a4ef5f8e5$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, nodeHandler) {
    const { ownerWindow: ownerWindow } = nodeHandler;
    const { getSize: getSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap && ownerWindow;
    const startGap = getStartGap();
    const endGap = getEndGap();
    const slideSizes = slideRects.map(getSize);
    const slideSizesWithGaps = getSlideSizesWithGaps();
    function getStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $a769d83a4ef5f8e5$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function getEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($a769d83a4ef5f8e5$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function getSlideSizesWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $a769d83a4ef5f8e5$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($a769d83a4ef5f8e5$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $a769d83a4ef5f8e5$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $a769d83a4ef5f8e5$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $a769d83a4ef5f8e5$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $a769d83a4ef5f8e5$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $a769d83a4ef5f8e5$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $a769d83a4ef5f8e5$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $a769d83a4ef5f8e5$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $a769d83a4ef5f8e5$var$Translate(axis, node) {
    const getTranslate = axis.scroll === 'x' ? x : y;
    const nodeStyle = node.style;
    let previousTarget;
    let disabled = false;
    function x(input) {
        return `translate3d(${input}px,0px,0px)`;
    }
    function y(input) {
        return `translate3d(0px,${input}px,0px)`;
    }
    function to(input) {
        if (disabled) return;
        const newTarget = $a769d83a4ef5f8e5$var$roundToTwoDecimals(axis.direction(input));
        if (newTarget === previousTarget) return;
        nodeStyle.transform = getTranslate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        nodeStyle.transform = '';
        if (!node.getAttribute('style')) node.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: $a769d83a4ef5f8e5$var$mapStoreToNumber(to),
        toggleActive: toggleActive
    };
    return self;
}
function $a769d83a4ef5f8e5$var$Engine(root, container, slides, options, nodeHandler, eventHandler, rects, isSsr) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startSnap: startSnap, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, inViewMargin: inViewMargin, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, draggable: draggable, resize: resize, slideChanges: slideChanges, focus: focus } = options;
    // Measurements
    const pixelTolerance = isSsr ? 0 : 2;
    const axis = $a769d83a4ef5f8e5$var$Axis(scrollAxis, direction);
    const { containerRect: containerRect, slideRects: slideRects } = rects;
    const viewSize = axis.getSize(containerRect);
    const percentOfView = $a769d83a4ef5f8e5$var$PercentOfView(viewSize);
    const alignment = $a769d83a4ef5f8e5$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $a769d83a4ef5f8e5$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, nodeHandler);
    const slidesToScroll = $a769d83a4ef5f8e5$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $a769d83a4ef5f8e5$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$a769d83a4ef5f8e5$var$arrayLast(snaps) + $a769d83a4ef5f8e5$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $a769d83a4ef5f8e5$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $a769d83a4ef5f8e5$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const indexCurrent = $a769d83a4ef5f8e5$var$Counter($a769d83a4ef5f8e5$var$arrayLastIndex(scrollSnaps), startSnap, loop);
    const indexPrevious = indexCurrent.clone();
    const slideIndexes = $a769d83a4ef5f8e5$var$arrayKeys(slides);
    // Animation
    const scrollAnimator = $a769d83a4ef5f8e5$var$ScrollAnimator();
    const animation = $a769d83a4ef5f8e5$var$Animations(()=>scrollAnimator.update(engine), (alpha)=>scrollAnimator.render(engine, alpha));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[indexCurrent.get()];
    const location = $a769d83a4ef5f8e5$var$NumberStore(startLocation);
    const previousLocation = $a769d83a4ef5f8e5$var$NumberStore(startLocation);
    const offsetLocation = $a769d83a4ef5f8e5$var$NumberStore(startLocation);
    const target = $a769d83a4ef5f8e5$var$NumberStore(startLocation);
    const translate = $a769d83a4ef5f8e5$var$Translate(axis, container);
    const slideTranslates = slides.map((slide)=>$a769d83a4ef5f8e5$var$Translate(axis, slide));
    const scrollProgress = $a769d83a4ef5f8e5$var$ScrollProgress(limit);
    const scrollBody = $a769d83a4ef5f8e5$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollSnapList = $a769d83a4ef5f8e5$var$ScrollSnapList(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes, scrollProgress);
    const slideLooper = $a769d83a4ef5f8e5$var$SlideLooper(viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slideTranslates);
    const scrollTarget = $a769d83a4ef5f8e5$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $a769d83a4ef5f8e5$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const eventStore = $a769d83a4ef5f8e5$var$EventStore();
    const slidesInView = $a769d83a4ef5f8e5$var$SlidesInView(container, slides, eventHandler, inViewThreshold, inViewMargin);
    const slideFocus = $a769d83a4ef5f8e5$var$SlideFocus(axis, focus, root, slides, scrollSnapList, scrollTo, scrollBody, eventStore, eventHandler);
    // Engine
    const engine = {
        eventHandler: eventHandler,
        containerRect: containerRect,
        contentSize: contentSize,
        slideRects: slideRects,
        nodeHandler: nodeHandler,
        animation: animation,
        slideSizes: slideSizes,
        isSsr: isSsr,
        axis: axis,
        dragHandler: $a769d83a4ef5f8e5$var$DragHandler(draggable, axis, root, target, $a769d83a4ef5f8e5$var$DragTracker(axis), location, animation, scrollTo, scrollBody, scrollTarget, indexCurrent, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction),
        eventStore: eventStore,
        percentOfView: percentOfView,
        indexCurrent: indexCurrent,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $a769d83a4ef5f8e5$var$ResizeHandler(resize, container, eventHandler, slides, axis, nodeHandler),
        scrollBody: scrollBody,
        scrollBounds: $a769d83a4ef5f8e5$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $a769d83a4ef5f8e5$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: slideLooper,
        slideFocus: slideFocus,
        slidesHandler: $a769d83a4ef5f8e5$var$SlidesHandler(slideChanges, container, eventHandler),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slidesToScroll: slidesToScroll,
        slideTranslates: slideTranslates,
        scrollSnapList: scrollSnapList,
        translate: translate,
        target: target
    };
    return engine;
}
function $a769d83a4ef5f8e5$var$EventHandler() {
    let eventStore = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getStore(type) {
        return eventStore[type] || [];
    }
    function setStore(type, update) {
        eventStore = Object.assign(Object.assign({}, eventStore), {
            [type]: update(getStore(type))
        });
        return self;
    }
    function createEventModel(type, detail) {
        return {
            api: api,
            type: type,
            detail: detail
        };
    }
    function createEvent(type, detail) {
        const event = {
            api: api,
            emit: ()=>emit(type, detail)
        };
        return event;
    }
    function emit(type, detail) {
        const event = createEventModel(type, detail);
        return getStore(type).every((handler)=>handler(api, event) !== false);
    }
    function on(type, callback) {
        setStore(type, (handlers)=>{
            return handlers.includes(callback) ? handlers : [
                ...handlers,
                callback
            ];
        });
        return self;
    }
    function off(type, callback) {
        setStore(type, (handlers)=>{
            return handlers.filter((handler)=>handler !== callback);
        });
        return self;
    }
    function clear() {
        eventStore = {};
    }
    const self = {
        init: init,
        clear: clear,
        createEvent: createEvent,
        on: on,
        off: off
    };
    return self;
}
const $a769d83a4ef5f8e5$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    inViewMargin: '0px',
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startSnap: 0,
    active: true,
    draggable: true,
    resize: true,
    focus: true,
    slideChanges: true
};
function $a769d83a4ef5f8e5$var$NodeHandler(root) {
    const ownerDocument = root ? root.ownerDocument : null;
    const ownerWindow = ownerDocument ? ownerDocument.defaultView : null;
    let rects;
    function getRect(node) {
        const { offsetTop: top, offsetLeft: left, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: top,
            right: left + offsetWidth,
            bottom: top + offsetHeight,
            left: left,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    function getRects(container, slides, fromCache) {
        if (fromCache && rects) return rects;
        const containerStyle = root ? container.style : {
            transform: ''
        };
        const previousTransform = containerStyle.transform;
        containerStyle.transform = 'none';
        const containerRect = getRect(container);
        const slideRects = slides.map(getRect);
        containerStyle.transform = previousTransform;
        rects = {
            containerRect: containerRect,
            slideRects: slideRects
        };
        return rects;
    }
    function getNodes(options) {
        if (!root) return {
            root: {},
            container: {},
            slides: []
        };
        const { container: userContainer, slides: userSlides } = options;
        const containerNode = $a769d83a4ef5f8e5$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        const container = containerNode || root.children[0];
        const slideNodes = $a769d83a4ef5f8e5$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        const slides = Array.from(slideNodes || container.children);
        return {
            root: root,
            container: container,
            slides: slides
        };
    }
    const self = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        getNodes: getNodes,
        getRect: getRect,
        getRects: getRects
    };
    return self;
}
function $a769d83a4ef5f8e5$var$OptionsHandler() {
    let windowInstance;
    function init(ownerWindow) {
        if (ownerWindow) windowInstance = ownerWindow;
    }
    function mergeOptions(optionsA, optionsB) {
        return $a769d83a4ef5f8e5$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        if (!windowInstance) return options;
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $a769d83a4ef5f8e5$var$objectKeys(optionsAtMedia).filter((media)=>windowInstance.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((mediaOptions, mediaOption)=>mergeOptions(mediaOptions, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        if (!windowInstance) return [];
        return optionsList.map((options)=>$a769d83a4ef5f8e5$var$objectKeys(options.breakpoints || {})).reduce((mediaQueries, mediaQuery)=>mediaQueries.concat(mediaQuery), []).map(windowInstance.matchMedia);
    }
    const self = {
        init: init,
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $a769d83a4ef5f8e5$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins;
        return plugins.reduce((pluginList, plugin)=>{
            plugin.init(emblaApi, optionsHandler);
            return Object.assign(Object.assign({}, pluginList), {
                [plugin.name]: plugin
            });
        }, {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $a769d83a4ef5f8e5$export$2e2bcd8739ae039(userRoot, userOptions, userPlugins) {
    const isSsr = !userRoot;
    const optionsHandler = $a769d83a4ef5f8e5$var$OptionsHandler();
    const pluginsHandler = $a769d83a4ef5f8e5$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $a769d83a4ef5f8e5$var$EventStore();
    const eventHandler = $a769d83a4ef5f8e5$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, createEvent: createEvent } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let nodeHandler;
    let optionsBase = mergeOptions($a769d83a4ef5f8e5$var$defaultOptions, $a769d83a4ef5f8e5$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis = {};
    let root;
    let container;
    let slides;
    function cloneEngine(userOptions) {
        const engineOptions = mergeOptions(options, userOptions);
        return createEngine(engineOptions, container, slides, true);
    }
    function createEngine(options, container, slides, useCachedRects) {
        const rects = nodeHandler.getRects(container, slides, useCachedRects);
        const engine = $a769d83a4ef5f8e5$var$Engine(root, container, slides, options, nodeHandler, eventHandler, rects, isSsr);
        if (options.loop && !engine.slideLooper.canLoop()) return cloneEngine({
            loop: false
        });
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        nodeHandler = $a769d83a4ef5f8e5$var$NodeHandler(userRoot);
        const { ownerWindow: ownerWindow } = nodeHandler;
        optionsHandler.init(ownerWindow);
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        let engineOptions = options;
        let nodes = nodeHandler.getNodes(options);
        const ssrHandler = $a769d83a4ef5f8e5$var$getSsrHandler(pluginList);
        if (isSsr && ssrHandler) {
            ssrHandler.setup(createEngine, mergeOptions, optionsBase);
            engineOptions = mergeOptions(engineOptions, {
                direction: 'ltr'
            });
            nodes = ssrHandler.getNodes();
        }
        root = nodes.root;
        container = nodes.container;
        slides = nodes.slides;
        engine = createEngine(engineOptions, container, slides);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        if (!isSsr && ownerWindow) {
            engine.translate.to(engine.location);
            if (engine.options.loop) engine.slideLooper.loop();
            engine.animation.init(ownerWindow);
            engine.resizeHandler.init(ownerWindow);
            engine.slidesInView.init(ownerWindow);
            engine.slidesHandler.init(ownerWindow);
            engine.slideFocus.init(ownerWindow);
            engine.eventHandler.init(self);
            if (container.offsetParent && slides.length) engine.dragHandler.init(ownerWindow);
        }
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const event = eventHandler.createEvent('reinit', null);
        const startSnap = selectedSnap();
        deActivate();
        activate(mergeOptions({
            startSnap: startSnap
        }, withOptions), withPlugins);
        event.emit();
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        engine.eventStore.clear();
        mediaHandlers.clear();
        engine.translate.clear();
        engine.slideTranslates.forEach((translate)=>translate.clear());
    }
    function destroy() {
        if (destroyed) return;
        if (isSsr) return;
        const event = eventHandler.createEvent('destroy', null);
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        event.emit();
        eventHandler.clear();
    }
    function goTo(index, instant, direction) {
        if (destroyed) return;
        if (isSsr) return;
        if (!options.active) return;
        engine.scrollBody.useBaseFriction().useDuration(instant === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction);
    }
    function goToNext(instant) {
        goTo(snapIndex(1), instant, -1);
    }
    function goToPrev(instant) {
        goTo(snapIndex(-1), instant, 1);
    }
    function canGoToNext() {
        return snapIndex(1) !== selectedSnap();
    }
    function canGoToPrev() {
        return snapIndex(-1) !== selectedSnap();
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation);
    }
    function snapIndex(offset) {
        return engine.indexCurrent.add(offset).get();
    }
    function snapList() {
        return engine.scrollSnapList.progressBySnap;
    }
    function selectedSnap() {
        return snapIndex(0);
    }
    function previousSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canGoToNext: canGoToNext,
        canGoToPrev: canGoToPrev,
        cloneEngine: cloneEngine,
        containerNode: containerNode,
        createEvent: createEvent,
        internalEngine: internalEngine,
        destroy: destroy,
        on: on,
        off: off,
        plugins: plugins,
        previousSnap: previousSnap,
        reInit: reInit,
        rootNode: rootNode,
        goToNext: goToNext,
        goToPrev: goToPrev,
        scrollProgress: scrollProgress,
        goTo: goTo,
        selectedSnap: selectedSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        snapIndex: snapIndex,
        snapList: snapList
    };
    activate(userOptions || {}, userPlugins || []);
    return self;
}
$a769d83a4ef5f8e5$export$2e2bcd8739ae039.globalOptions = undefined;

});

parcelRegister("2j4kE", function(module, exports) {

$parcel$export(module.exports, "WheelGesturesPlugin", () => $1ae0b75b69b50141$export$1c3f64aa406d3265);

var $hMrBt = parcelRequire("hMrBt");
const $1ae0b75b69b50141$var$n = {
    active: !0,
    breakpoints: {},
    wheelDraggingClass: "is-wheel-dragging",
    forceWheelAxis: void 0,
    target: void 0
};
function $1ae0b75b69b50141$export$1c3f64aa406d3265(o = {}) {
    let s = ()=>{};
    return {
        name: "wheelGestures",
        options: o,
        init: function(i, r) {
            var a, c;
            s();
            const { mergeOptions: l, optionsAtMedia: u } = r, g = u(l(l($1ae0b75b69b50141$var$n, $1ae0b75b69b50141$export$1c3f64aa406d3265.globalOptions), o)), d = i.internalEngine();
            if (d.isSsr || !g.active) return;
            const f = null !== (a = g.target) && void 0 !== a ? a : i.containerNode().parentNode, h = i.containerNode().ownerDocument.defaultView, p = null !== (c = g.forceWheelAxis) && void 0 !== c ? c : d.options.axis, m = "x" === p ? 0 : 1, w = (0, $hMrBt.default)({
                preventWheelAction: p,
                reverseSign: [
                    !0,
                    !0,
                    !1
                ]
            }), { axis: M, target: v, location: b, scrollBody: D, scrollTarget: x, scrollTo: C, indexCurrent: B, animation: F } = d, y = !0 === d.options.dragFree || "snap" === d.options.dragFree, S = !0 !== d.options.dragFree;
            let A = !1, O = !1, k = 0, z = 0, L = 0, N = 0, W = 0, E = 0;
            function P() {
                z = M.getSize(d.containerRect);
            }
            const T = d.scrollBounds.constrain, V = (e)=>T(e || A);
            function G() {
                if (!A) return;
                A = !1, g.wheelDraggingClass && f.classList.remove(g.wheelDraggingClass);
                const e = h.performance.now(), n = e - W, t = n && e - E <= 170 ? (L - N) / n : 0, o = (Math.abs(t) > .1 ? t : 0) * (y ? 500 : 300), s = function(e) {
                    const n = Math.min(225, Math.max(50, d.percentOfView.measure(20))), t = ()=>x.byDistance(e, S).distance;
                    if (y || Math.abs(e) < n) return t();
                    if (d.options.skipSnaps && x.byDistance(0, !1).index !== B.get()) return .5 * t();
                    const o = B.add(-Math.sign(e));
                    return x.byIndex(o.get(), 0).distance;
                }(M.direction(o)), i = o && s && Math.abs(o) > Math.abs(s) ? (Math.abs(o) - Math.abs(s)) / Math.abs(o) : 0;
                D.useDuration((y ? 43 : 25) - 10 * i), D.useFriction(.68 + i / 50), C.distance(s, S);
            }
            function H() {
                A && (O = !0, G());
            }
            d.scrollBounds.constrain = V, P(), i.on("resize", P), i.on("pointerdown", H);
            const I = w.observe(f), R = w.on("wheel", function(e) {
                if (e.isEnding) return G(), void (O = !1);
                if (d.dragHandler.pointerDown()) return void (O = !0);
                if (O) return;
                if (e.isMomentum) return void G();
                const n = e.axisDelta[m], t = e.axisDelta[0 === m ? 1 : 0];
                if (!A && Math.abs(n) > Math.abs(t) && (A = !0, k = 0, L = N = 0, E = W = h.performance.now(), D.useFriction(0).useDuration(0), v.set(b), g.wheelDraggingClass && f.classList.add(g.wheelDraggingClass)), !A) return;
                const o = function(e) {
                    if (d.options.loop) return !1;
                    const n = M.direction(e);
                    return n < 0 && i.scrollProgress() >= 1 || n > 0 && i.scrollProgress() <= 0;
                }(n);
                if (k = o ? k + Math.abs(n) : 0, o && k > z / 2) return O = !0, void G();
                !function(e, n) {
                    let t = e.axisMovement[m];
                    if (n && z) {
                        const e = Math.min(k / (z / 2), 1);
                        t -= Math.sign(t) * k * (.25 + .5 * e);
                    }
                    d.options.skipSnaps || y || (t = Math.max(-z, Math.min(t, z)));
                    const o = h.performance.now(), s = t - L;
                    o - W > 170 && (W = o, N = t), L = t, E = o, D.useFriction(.3).useDuration(.75), v.add(M.direction(s)), F.start();
                }(e, o);
            });
            s = ()=>{
                A && (A = !1, v.set(b), D.useBaseDuration().useBaseFriction()), g.wheelDraggingClass && f.classList.remove(g.wheelDraggingClass), I(), R(), i.off("resize", P), i.off("pointerdown", H), d.scrollBounds.constrain === V && (d.scrollBounds.constrain = T), s = ()=>{};
            };
        },
        destroy: ()=>s()
    };
}
$1ae0b75b69b50141$export$1c3f64aa406d3265.globalOptions = void 0;

});
parcelRegister("hMrBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1c54d26b22998b$export$2e2bcd8739ae039);
function $cf1c54d26b22998b$var$_extends() {
    $cf1c54d26b22998b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf1c54d26b22998b$var$_extends.apply(this, arguments);
}
var $cf1c54d26b22998b$var$DECAY = 0.996;
/**
 * movement projection based on velocity
 * @param velocityPxMs
 * @param decay
 */ var $cf1c54d26b22998b$export$b74061472fe7c07 = function projection(velocityPxMs, decay) {
    if (decay === void 0) decay = $cf1c54d26b22998b$var$DECAY;
    return velocityPxMs * decay / (1 - decay);
};
function $cf1c54d26b22998b$export$891a5c5c55cf41aa(array) {
    return array[array.length - 1];
}
function $cf1c54d26b22998b$export$cc6710ee5f037d57(numbers) {
    return numbers.reduce(function(a, b) {
        return a + b;
    }) / numbers.length;
}
var $cf1c54d26b22998b$export$7d15b64cf5a3a4c4 = function clamp(value, min, max) {
    return Math.min(Math.max(min, value), max);
};
function $cf1c54d26b22998b$export$75064e1c6824e15c(v1, v2) {
    if (v1.length !== v2.length) throw new Error('vectors must be same length');
    return v1.map(function(val, i) {
        return val + v2[i];
    });
}
function $cf1c54d26b22998b$export$bb8a7d60274b5fc6(numbers) {
    return Math.max.apply(Math, numbers.map(Math.abs));
} // eslint-disable-next-line @typescript-eslint/ban-types
function $cf1c54d26b22998b$export$7e32b29e1cb162e1(o) {
    Object.freeze(o);
    Object.values(o).forEach(function(value) {
        if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) $cf1c54d26b22998b$export$7e32b29e1cb162e1(value);
    });
    return o;
}
function $cf1c54d26b22998b$var$EventBus() {
    var listeners = {};
    function on(type, listener) {
        listeners[type] = (listeners[type] || []).concat(listener);
        return function() {
            return off(type, listener);
        };
    }
    function off(type, listener) {
        listeners[type] = (listeners[type] || []).filter(function(l) {
            return l !== listener;
        });
    }
    function dispatch(type, data) {
        if (!(type in listeners)) return;
        listeners[type].forEach(function(l) {
            return l(data);
        });
    }
    return $cf1c54d26b22998b$export$7e32b29e1cb162e1({
        on: on,
        off: off,
        dispatch: dispatch
    });
}
function $cf1c54d26b22998b$var$WheelTargetObserver(eventListener) {
    var targets = []; // add event listener to target element
    var observe = function observe(target) {
        target.addEventListener('wheel', eventListener, {
            passive: false
        });
        targets.push(target);
        return function() {
            return unobserve(target);
        };
    }; /// remove event listener from target element
    var unobserve = function unobserve(target) {
        target.removeEventListener('wheel', eventListener);
        targets = targets.filter(function(t) {
            return t !== target;
        });
    }; // stops watching all of its target elements for visibility changes.
    var disconnect = function disconnect() {
        targets.forEach(unobserve);
    };
    return $cf1c54d26b22998b$export$7e32b29e1cb162e1({
        observe: observe,
        unobserve: unobserve,
        disconnect: disconnect
    });
}
var $cf1c54d26b22998b$var$LINE_HEIGHT = 18;
var $cf1c54d26b22998b$var$PAGE_HEIGHT = typeof window !== 'undefined' && window.innerHeight || 800;
var $cf1c54d26b22998b$var$DELTA_MODE_UNIT = [
    1,
    $cf1c54d26b22998b$var$LINE_HEIGHT,
    $cf1c54d26b22998b$var$PAGE_HEIGHT
];
function $cf1c54d26b22998b$var$normalizeWheel(e) {
    var deltaX = e.deltaX * $cf1c54d26b22998b$var$DELTA_MODE_UNIT[e.deltaMode];
    var deltaY = e.deltaY * $cf1c54d26b22998b$var$DELTA_MODE_UNIT[e.deltaMode];
    var deltaZ = (e.deltaZ || 0) * $cf1c54d26b22998b$var$DELTA_MODE_UNIT[e.deltaMode];
    return {
        timeStamp: e.timeStamp,
        axisDelta: [
            deltaX,
            deltaY,
            deltaZ
        ]
    };
}
var $cf1c54d26b22998b$var$reverseAll = [
    -1,
    -1,
    -1
];
function $cf1c54d26b22998b$var$reverseAxisDeltaSign(wheel, reverseSign) {
    if (!reverseSign) return wheel;
    var multipliers = reverseSign === true ? $cf1c54d26b22998b$var$reverseAll : reverseSign.map(function(shouldReverse) {
        return shouldReverse ? -1 : 1;
    });
    return $cf1c54d26b22998b$var$_extends({}, wheel, {
        axisDelta: wheel.axisDelta.map(function(delta, i) {
            return delta * multipliers[i];
        })
    });
}
var $cf1c54d26b22998b$var$DELTA_MAX_ABS = 700;
var $cf1c54d26b22998b$var$clampAxisDelta = function clampAxisDelta(wheel) {
    return $cf1c54d26b22998b$var$_extends({}, wheel, {
        axisDelta: wheel.axisDelta.map(function(delta) {
            return $cf1c54d26b22998b$export$7d15b64cf5a3a4c4(delta, -$cf1c54d26b22998b$var$DELTA_MAX_ABS, $cf1c54d26b22998b$var$DELTA_MAX_ABS);
        })
    });
};
var $cf1c54d26b22998b$var$__DEV__ = false;
var $cf1c54d26b22998b$var$ACC_FACTOR_MIN = 0.6;
var $cf1c54d26b22998b$var$ACC_FACTOR_MAX = 0.96;
var $cf1c54d26b22998b$var$WHEELEVENTS_TO_MERGE = 2;
var $cf1c54d26b22998b$var$WHEELEVENTS_TO_ANALAZE = 5;
var $cf1c54d26b22998b$export$3208dd15ca232a1a = /*#__PURE__*/ $cf1c54d26b22998b$export$7e32b29e1cb162e1({
    preventWheelAction: true,
    reverseSign: [
        true,
        true,
        false
    ]
});
var $cf1c54d26b22998b$var$WILL_END_TIMEOUT_DEFAULT = 400;
function $cf1c54d26b22998b$var$createWheelGesturesState() {
    return {
        isStarted: false,
        isStartPublished: false,
        isMomentum: false,
        startTime: 0,
        lastAbsDelta: Infinity,
        axisMovement: [
            0,
            0,
            0
        ],
        axisVelocity: [
            0,
            0,
            0
        ],
        accelerationFactors: [],
        scrollPoints: [],
        scrollPointsToMerge: [],
        willEndTimeout: $cf1c54d26b22998b$var$WILL_END_TIMEOUT_DEFAULT
    };
}
function $cf1c54d26b22998b$export$fd0a73f04f41aa21(optionsParam) {
    if (optionsParam === void 0) optionsParam = {};
    var _EventBus = $cf1c54d26b22998b$var$EventBus(), on = _EventBus.on, off = _EventBus.off, dispatch = _EventBus.dispatch;
    var config = $cf1c54d26b22998b$export$3208dd15ca232a1a;
    var state = $cf1c54d26b22998b$var$createWheelGesturesState();
    var currentEvent;
    var negativeZeroFingerUpSpecialEvent = false;
    var prevWheelEventState;
    var feedWheel = function feedWheel(wheelEvents) {
        if (Array.isArray(wheelEvents)) wheelEvents.forEach(function(wheelEvent) {
            return processWheelEventData(wheelEvent);
        });
        else processWheelEventData(wheelEvents);
    };
    var updateOptions = function updateOptions(newOptions) {
        if (newOptions === void 0) newOptions = {};
        if (Object.values(newOptions).some(function(option) {
            return option === undefined || option === null;
        })) {
            $cf1c54d26b22998b$var$__DEV__ && console.error('updateOptions ignored! undefined & null options not allowed');
            return config;
        }
        return config = $cf1c54d26b22998b$export$7e32b29e1cb162e1($cf1c54d26b22998b$var$_extends({}, $cf1c54d26b22998b$export$3208dd15ca232a1a, config, newOptions));
    };
    var publishWheel = function publishWheel(additionalData) {
        var wheelEventState = $cf1c54d26b22998b$var$_extends({
            event: currentEvent,
            isStart: false,
            isEnding: false,
            isMomentumCancel: false,
            isMomentum: state.isMomentum,
            axisDelta: [
                0,
                0,
                0
            ],
            axisVelocity: state.axisVelocity,
            axisMovement: state.axisMovement,
            get axisMovementProjection () {
                return $cf1c54d26b22998b$export$75064e1c6824e15c(wheelEventState.axisMovement, wheelEventState.axisVelocity.map(function(velocity) {
                    return $cf1c54d26b22998b$export$b74061472fe7c07(velocity);
                }));
            }
        }, additionalData);
        dispatch('wheel', $cf1c54d26b22998b$var$_extends({}, wheelEventState, {
            previous: prevWheelEventState
        })); // keep reference without previous, otherwise we would create a long chain
        prevWheelEventState = wheelEventState;
    }; // should prevent when there is mainly movement on the desired axis
    var shouldPreventDefault = function shouldPreventDefault(deltaMaxAbs, axisDelta) {
        var _config = config, preventWheelAction = _config.preventWheelAction;
        var deltaX = axisDelta[0], deltaY = axisDelta[1], deltaZ = axisDelta[2];
        if (typeof preventWheelAction === 'boolean') return preventWheelAction;
        switch(preventWheelAction){
            case 'x':
                return Math.abs(deltaX) >= deltaMaxAbs;
            case 'y':
                return Math.abs(deltaY) >= deltaMaxAbs;
            case 'z':
                return Math.abs(deltaZ) >= deltaMaxAbs;
            default:
                $cf1c54d26b22998b$var$__DEV__ && console.warn('unsupported preventWheelAction value: ' + preventWheelAction, 'warn');
                return false;
        }
    };
    var processWheelEventData = function processWheelEventData(wheelEvent) {
        var _clampAxisDelta = $cf1c54d26b22998b$var$clampAxisDelta($cf1c54d26b22998b$var$reverseAxisDeltaSign($cf1c54d26b22998b$var$normalizeWheel(wheelEvent), config.reverseSign)), axisDelta = _clampAxisDelta.axisDelta, timeStamp = _clampAxisDelta.timeStamp;
        var deltaMaxAbs = $cf1c54d26b22998b$export$bb8a7d60274b5fc6(axisDelta);
        var nativeMomentum = typeof wheelEvent.momentum === 'boolean' ? wheelEvent.momentum : undefined;
        if (wheelEvent.preventDefault && shouldPreventDefault(deltaMaxAbs, axisDelta)) wheelEvent.preventDefault();
        if (!state.isStarted) start();
        else if (state.isMomentum && (nativeMomentum === false || nativeMomentum === undefined && deltaMaxAbs > Math.max(2, state.lastAbsDelta * 2))) {
            end(true);
            start();
        } // special finger up event on windows + blink
        if (nativeMomentum === undefined && deltaMaxAbs === 0 && Object.is && Object.is(wheelEvent.deltaX, -0)) {
            negativeZeroFingerUpSpecialEvent = true; // return -> zero delta event should not influence velocity
            return;
        }
        currentEvent = wheelEvent;
        if (nativeMomentum !== undefined) {
            state.isMomentum = nativeMomentum;
            negativeZeroFingerUpSpecialEvent = false;
        }
        state.axisMovement = $cf1c54d26b22998b$export$75064e1c6824e15c(state.axisMovement, axisDelta);
        state.lastAbsDelta = deltaMaxAbs;
        state.scrollPointsToMerge.push({
            axisDelta: axisDelta,
            timeStamp: timeStamp
        });
        mergeScrollPointsCalcVelocity(); // only wheel event (move) and not start/end get the delta values
        publishWheel({
            axisDelta: axisDelta,
            isStart: !state.isStartPublished
        }); // state.isMomentum ? MOMENTUM_WHEEL : WHEEL, { axisDelta })
        // publish start after velocity etc. have been updated
        state.isStartPublished = true; // calc debounced end function, to recognize end of wheel event stream
        willEnd();
    };
    var mergeScrollPointsCalcVelocity = function mergeScrollPointsCalcVelocity() {
        if (state.scrollPointsToMerge.length === $cf1c54d26b22998b$var$WHEELEVENTS_TO_MERGE) {
            state.scrollPoints.unshift({
                axisDeltaSum: state.scrollPointsToMerge.map(function(b) {
                    return b.axisDelta;
                }).reduce($cf1c54d26b22998b$export$75064e1c6824e15c),
                timeStamp: $cf1c54d26b22998b$export$cc6710ee5f037d57(state.scrollPointsToMerge.map(function(b) {
                    return b.timeStamp;
                }))
            }); // only update velocity after a merged scrollpoint was generated
            updateVelocity(); // reset toMerge array
            state.scrollPointsToMerge.length = 0; // after calculation of velocity only keep the most recent merged scrollPoint
            state.scrollPoints.length = 1;
            if (!state.isMomentum && typeof currentEvent.momentum !== 'boolean') detectMomentum();
        } else if (!state.isStartPublished) updateStartVelocity();
    };
    var updateStartVelocity = function updateStartVelocity() {
        state.axisVelocity = $cf1c54d26b22998b$export$891a5c5c55cf41aa(state.scrollPointsToMerge).axisDelta.map(function(d) {
            return d / state.willEndTimeout;
        });
    };
    var updateVelocity = function updateVelocity() {
        // need to have two recent points to calc velocity
        var _state$scrollPoints = state.scrollPoints, latestScrollPoint = _state$scrollPoints[0], prevScrollPoint = _state$scrollPoints[1];
        if (!prevScrollPoint || !latestScrollPoint) return;
         // time delta
        var deltaTime = latestScrollPoint.timeStamp - prevScrollPoint.timeStamp;
        if (deltaTime <= 0) {
            $cf1c54d26b22998b$var$__DEV__ && console.warn('invalid deltaTime');
            return;
        } // calc the velocity per axes
        var velocity = latestScrollPoint.axisDeltaSum.map(function(d) {
            return d / deltaTime;
        }); // calc the acceleration factor per axis
        var accelerationFactor = velocity.map(function(v, i) {
            return v / (state.axisVelocity[i] || 1);
        });
        state.axisVelocity = velocity;
        state.accelerationFactors.push(accelerationFactor);
        updateWillEndTimeout(deltaTime);
    };
    var updateWillEndTimeout = function updateWillEndTimeout(deltaTime) {
        // use current time between events rounded up and increased by a bit as timeout
        var newTimeout = Math.ceil(deltaTime / 10) * 12; // double the timeout, when momentum was not detected yet
        if (!state.isMomentum) newTimeout = Math.max(100, newTimeout * 2);
        state.willEndTimeout = Math.min(1000, Math.round(newTimeout));
    };
    var accelerationFactorInMomentumRange = function accelerationFactorInMomentumRange(accFactor) {
        // when main axis is the the other one and there is no movement/change on the current one
        if (accFactor === 0) return true;
        return accFactor <= $cf1c54d26b22998b$var$ACC_FACTOR_MAX && accFactor >= $cf1c54d26b22998b$var$ACC_FACTOR_MIN;
    };
    var detectMomentum = function detectMomentum() {
        if (state.accelerationFactors.length >= $cf1c54d26b22998b$var$WHEELEVENTS_TO_ANALAZE) {
            if (negativeZeroFingerUpSpecialEvent) {
                negativeZeroFingerUpSpecialEvent = false;
                if ($cf1c54d26b22998b$export$bb8a7d60274b5fc6(state.axisVelocity) >= 0.2) {
                    recognizedMomentum();
                    return;
                }
            }
            var recentAccelerationFactors = state.accelerationFactors.slice($cf1c54d26b22998b$var$WHEELEVENTS_TO_ANALAZE * -1); // check recent acceleration / deceleration factors
            // all recent need to match, if any did not match
            var detectedMomentum = recentAccelerationFactors.every(function(accFac) {
                // when both axis decelerate exactly in the same rate it is very likely caused by momentum
                var sameAccFac = !!accFac.reduce(function(f1, f2) {
                    return f1 && f1 < 1 && f1 === f2 ? 1 : 0;
                }); // check if acceleration factor is within momentum range
                var bothAreInRangeOrZero = accFac.filter(accelerationFactorInMomentumRange).length === accFac.length; // one the requirements must be fulfilled
                return sameAccFac || bothAreInRangeOrZero;
            });
            if (detectedMomentum) recognizedMomentum();
             // only keep the most recent events
            state.accelerationFactors = recentAccelerationFactors;
        }
    };
    var recognizedMomentum = function recognizedMomentum() {
        state.isMomentum = true;
    };
    var start = function start() {
        state = $cf1c54d26b22998b$var$createWheelGesturesState();
        state.isStarted = true;
        state.startTime = Date.now();
        prevWheelEventState = undefined;
        negativeZeroFingerUpSpecialEvent = false;
    };
    var willEnd = function() {
        var willEndId;
        return function() {
            clearTimeout(willEndId);
            willEndId = setTimeout(end, state.willEndTimeout);
        };
    }();
    var end = function end(isMomentumCancel) {
        if (isMomentumCancel === void 0) isMomentumCancel = false;
        if (!state.isStarted) return;
        if (state.isMomentum && isMomentumCancel) publishWheel({
            isEnding: true,
            isMomentumCancel: true
        });
        else publishWheel({
            isEnding: true
        });
        state.isMomentum = false;
        state.isStarted = false;
    };
    var _WheelTargetObserver = $cf1c54d26b22998b$var$WheelTargetObserver(feedWheel), observe = _WheelTargetObserver.observe, unobserve = _WheelTargetObserver.unobserve, disconnect = _WheelTargetObserver.disconnect;
    updateOptions(optionsParam);
    return $cf1c54d26b22998b$export$7e32b29e1cb162e1({
        on: on,
        off: off,
        observe: observe,
        unobserve: unobserve,
        disconnect: disconnect,
        feedWheel: feedWheel,
        updateOptions: updateOptions
    });
}
var $cf1c54d26b22998b$export$2e2bcd8739ae039 = $cf1c54d26b22998b$export$fd0a73f04f41aa21;

});



//# sourceMappingURL=vanilla.e5170dab.js.map
